import { createSlice } from "@reduxjs/toolkit";
import getRadiologistList from "@custom/rtk-apis/billing/consultation/getRadiologistList";

const initialState = {
  status:"",
  result:null,
  msg:"",
  loading:false,
  error:""
};

const getRadiologistListSlice = createSlice({
  name: "getRadiologistListSlice",
  initialState,
  reducers: {
    clearRadiologistList: state => {
      state.status = '';
      state.result = '';
      state.msg = '';
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getRadiologistList.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getRadiologistList.fulfilled, (state, { payload }) => {
        console.log("Fulfilled123123",payload)
        state.loading = false;
        state.status = "SUCCESS";
        state.result = payload.data;
        state.msg = "Successfully fetched radiologist list";
      })
      .addCase(getRadiologistList.rejected, (state, { payload }) => {
        state.result = payload;
        state.loading = false;
      });
  },
});

export default getRadiologistListSlice.reducer;
export const { clearRadiologistList } = getRadiologistListSlice.actions;
